export default __webpack_public_path__ + "static/what-is-it-3-4f7473210e624d77762ccd4935615c9c.png";